const deviceInfo = {
  system: navigator.userAgent,
  app: {
    version: '1.0.14',
    name: 'EasyPixy',
  },
};

export { deviceInfo };
